if (document.querySelector('.halfbox-slider')) {

    import('@splidejs/splide/dist/css/splide-core.min.css')
        .then(() => import('../../js/components/splide.js'));

}

if (document.querySelector('.js-video-background')) {

    import('../../js/components/video-background.js');

}
